import React  from "react";
import { useDispatch } from "react-redux";
import { Icon } from "rhombus-react";

import { openModal } from 'reducers/Modal';
import { MODAL_TYPES } from 'utils/constants';


export function EditPartnerVAST(props){
	let dispatch = useDispatch();

	function handleClick(){
		dispatch(openModal(MODAL_TYPES.EDIT_PARTNER_VAST, {
			id:props.creativeId,
			name:props.creativeName,
			vastTag:props.vastTag,
		})
		);
	}

	return (
		<div className="action-icon">
			<Icon
				data-tip="Edit Creative"
				name="edit"
				className="bounce-circle"
				onClick={() => {
					handleClick();
				}}
			/>
		</div>
	);
}
